<script>
    import shift$ from "../stores/shift$";
    import {formatDate} from "../lib/lib";
    import DurationControl from "../components/controls/DurationControl.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";

    export let openClockingShift;
</script>

{#if $shift$.id > 0}
    <div class="panel-simple panel-pad shift-panel mb-4">
        <div class="text-gray mb-1">
            {$shift$.vehicle.licence_no}
        </div>
        <button class="btn btn-reset d-flex align-items-center gap-2 fs-5 mb-1"
                on:click={() => openClockingShift($shift$)}>
            <span class="d-block text-gray"><AppIcon icon="clock" size="20" strokeWidth="2"/></span>
            <span class="d-block text-gray">{formatDate($shift$.start_at, 'd-m-y H:i')}</span>
            <DurationControl duration={$shift$.duration}/>
        </button>
        <div class="text-gray small">
            Click to edit clocking shift
        </div>
    </div>
{/if}

<style>
    .shift-panel {
        width: max-content;
        max-width: 100%;
    }

    @media (max-width: 576px) {
        .shift-panel {
            width: 100%;
            max-width: 100%;
        }
        .shift-panel button {
            width: 100%;
        }
    }
</style>